export default {
    layoutLimits: {
        minWidth: 26,
        minHeight: 26
    }
}
